import { render, staticRenderFns } from "./Loading1.vue?vue&type=template&id=0b85b608&scoped=true&"
import script from "./Loading1.vue?vue&type=script&lang=js&"
export * from "./Loading1.vue?vue&type=script&lang=js&"
import style0 from "./Loading1.vue?vue&type=style&index=0&id=0b85b608&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85b608",
  null
  
)

export default component.exports